import { Percomatic } from '@biggby-coffee/percomatic-typescript';

export const moneyToCents = (money: Percomatic.Serialized.Money): number =>
	Math.round(Number(Number(money).toFixed(2)) * 100);
